/** @file blendNodeKey: two node keys blended (continuous fields interpolated, discrete fields switched). */
import type { NodeKey } from '@zilo/pose3d-format/types/clip';
import { discreteFields } from './discreteFields';
import { lerpNodeKey } from './lerpNodeKey';

/** `lerpNodeKey(a, b, t)` with `parent`, `rotToggle`, `hidden` from `a` when `t < 0.5`, else from `b`. */
export function blendNodeKey(a: NodeKey, b: NodeKey, t: number): NodeKey {
  return { ...lerpNodeKey(a, b, t), ...discreteFields(t < 0.5 ? a : b) };
}
